import React from "react";
import { safeLocalFormat } from "../../../utilities/functions";

const localDate = ({ row }) => {
  return <div>{row.checkInDate ? safeLocalFormat(row.checkInDate) : "-"}</div>;
};

export default localDate;
